import React, { FC } from "react";

// Status pill map — mirrors docs/pms-design-system.md §6.
export interface StatusMetaEntry {
  dot: string;
  text: string;
  bg: string;
}

export const STATUS_META: Record<string, StatusMetaEntry> = {
  Draft: { dot: "#faad14", text: "#ad6800", bg: "#fffbe6" },
  Active: { dot: "#52c41a", text: "#237804", bg: "#f6ffed" },
  Inactive: { dot: "#8094ae", text: "#526484", bg: "#f0f2f5" },
  Closed: { dot: "#2557d6", text: "#1a4d8f", bg: "#e5ebfa" },
  Archived: { dot: "#722ed1", text: "#531dab", bg: "#f9f0ff" },
  "Recycle Bin": { dot: "#f5222d", text: "#a8071a", bg: "#fff1f0" },
};

const FALLBACK_META: StatusMetaEntry = STATUS_META.Inactive;

export const statusMetaFor = (status?: string): StatusMetaEntry =>
  (status && STATUS_META[status]) || FALLBACK_META;

// The navigate contract's extra.screenName historically matched the source
// list page ("Active", "Draft", ...) — derive it from the row's own status.
export const screenNameForStatus = (status?: string): string =>
  status || "Active";

export const ALL_STATUSES = [
  "Active",
  "Draft",
  "Inactive",
  "Closed",
  "Archived",
];

export const StatusPill: FC<{ status?: string }> = ({ status }) => {
  const meta = statusMetaFor(status);
  return (
    <span
      className="pms-status-pill"
      style={{ background: meta.bg, color: meta.text }}
    >
      <span className="pms-status-dot" style={{ background: meta.dot }} />
      {status || "—"}
    </span>
  );
};
